import { NumberValue, VALUE_TYPE } from "Components/NumberValue";

import { YesOrNo } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Boolean";
import { DisabilityProduct } from "Store/interfaces/products/checkout/lifeProducts/DisabilityProduct";
import { isDefined } from "Utils/functions";
import React from "react";
import { ProductDetail } from "../../interface";

export const disabilityDetailsList = (
  product: DisabilityProduct,
  types: any,
  lang: string,
): ProductDetail[] => [
  {
    name: "yearlyIncome",
    value: <NumberValue type={VALUE_TYPE.NOK} value={product.yearlyIncome} />,
  },
  {
    name: "workStatus",
    value: types.workStatus[product.workStatus][lang],
  },
  {
    name: "education",
    value: types.education[product.education][lang],
  },
  {
    name: "hasEmployerPaidDisabilityInsurance",
    value: (
      <YesOrNo value={product.hasEmployerPaidDisabilityInsurance ?? false} />
    ),
  },
  {
    name: "paymentAfter3Months",
    value: product.paymentAfter3Months
      ? types.paymentAfter.threeMonths[lang]
      : types.paymentAfter.twelveMonths[lang],
    hidden: !isDefined(product.paymentAfter3Months),
  },
];
